import React, { Component } from 'react';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import cx from 'classnames';
import { Form } from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';

import Link from '../../../Link/Link';
import Loader from '../../../Common/Loader/Loader';

import messages from '../../../../locale/messages';

import validate from './validate';
import onSubmit from './submit';
import InputFieldComponent from '../../../Common/InputFieldComponent/InputFieldComponent';

import bt from '../../../../components/commonStyle.css';
import s from './SmsForm.css';

export class SmsForm extends Component {

	render() {
		const { handleSubmit, loading, submitting, id } = this.props;
		const { formatMessage } = this.props.intl;

		return (
			<Form className={s.fullWidth} onSubmit={handleSubmit(onSubmit)}>
				<h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.editSmsMethod)}</h1>
				<div className='twoColumnGrid'>
					<Field
						name="accountId"
						type="text"
						inputClass={bt.formControlInput}
						placeholder={id == 2 ? formatMessage(messages.accountId) : formatMessage(messages.apiKey)}
						component={InputFieldComponent}
						label={id == 2 ? formatMessage(messages.accountId) : formatMessage(messages.apiKey)}
						toolTipText={id == 2 ? formatMessage(messages.accountIDToolTip) : formatMessage(messages.apiKeyToolTip)}
						showToolTip

					/>
					<Field
						name="securityId"
						type="text"
						inputClass={bt.formControlInput}
						placeholder={id == 2 ? formatMessage(messages.secretId) : formatMessage(messages.secretKey)}
						component={InputFieldComponent}
						label={id == 2 ? formatMessage(messages.secretId) : formatMessage(messages.secretKey)}
						toolTipText={id == 2 ? formatMessage(messages.authtokenToolTip) : formatMessage(messages.secretKeyToolTip)}
						showToolTip
					/>
					<Field
						name="phoneNumber"
						type="text"
						inputClass={bt.formControlInput}
						placeholder={formatMessage(messages.senderId)}
						component={InputFieldComponent}
						label={formatMessage(messages.senderId)}
						toolTipText={formatMessage(messages.senderToolTip)}
						showToolTip
					/>
				</div>
				<div className='commonButtonContainer'>
					<Link to={"/siteadmin/sms-methods"} className={bt.btnSecondary} >{formatMessage(messages.goBack)}</Link>
					<Loader
						type={"button"}
						label={formatMessage(messages.update)}
						show={loading}
						buttonType={'submit'}
						className={cx(bt.btnPrimary, 'loaderButtonFlex')}
						disabled={submitting || loading}
					/>
				</div>
			</Form>
		)
	}
}

SmsForm = reduxForm({
	form: 'SmsForm',
	onSubmit,
	validate
})(SmsForm);

const selector = formValueSelector('SmsForm');
const mapState = state => ({
	id: selector(state, 'id'),
	loading: state.loader.UpdateSmsMethod,
});

const mapDispatch = {};

export default injectIntl(withStyles(bt, s)(connect(mapState, mapDispatch)(SmsForm)));